goog.provide('el8.appchart.refpanel.util');

el8.appchart.refpanel.util = (function() {

    return {

        highlightEntry: function(itemId, duration) {
            duration = duration || 10000;

            var $refPanel = $('#refBoardContainer');
            // first look for an li. This applies to allergies, problems, meds:
            // the things that aren't listeditors
            var $elt = $('li[data-id="'+itemId+'"]', $refPanel);
            if (!$elt.length) {
                // then look inside the listeditors
                var $elt = $('.le-entry[_id="'+itemId+'"]', $refPanel);
            }

            if ($elt.length) {
                $elt.addClass('el8BlueHighlight');
                $.el8_setTimeout(function() {
                    $elt.removeClass('el8BlueHighlight');
                }, duration);
            }
        }
    };

})();
